module.exports = __webpack_public_path__ + "img/yewufushe.12ecddf7.png";